import { render, staticRenderFns } from "./champ_wysiwyg.vue?vue&type=template&id=7a3f58b2"
import script from "./champ_wysiwyg.js?vue&type=script&lang=js&external"
export * from "./champ_wysiwyg.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports